import { useEffect, useState } from 'react'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Box } from '@mui/system'
import { connect } from 'react-redux'
import DropDownOA from '../../../../common/dropDownOA'
import * as id from '../../reportId'
import * as lb from '../../reportLables'
import { Button } from '@mui/material'
import Datepicker from '../../../../common/datePicker'
import moment from 'moment'
import { addDaysToDate, appendToUrl, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray, subtractDaysFromDate } from '../../../../common/helper'
import { SplitButton } from '../../../../common/SplitButton'
import { GetMOFPaymentUpdate, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { TULSI_TRAVEL, STA_COMPANY_ID } from '../../../../../helper/companyIdhardcode'
import { cancelFranchiseDeliveryDetailedColumn, frenchDeliveryUpdatedColumn, reportViewList, summaryColumn } from './DelFranchiseeConstant'
import { getCompanyList, getFranchiseeDeliveryReportFilterData, getFranchiseeDeliveryReportTableData } from '../../../../../store/reports/reports_action'
import { paymentModesWithAll } from '../../../../common/paymentsMode'
import { paymentModeAll, reportTypeFranchiseDeliveryFilter } from '../../../../common/constants'
import * as urls from '../../oldReportsUrls'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../../common/jotaiState/reportStateAtom'
import { useAtom, useSetAtom } from 'jotai'
import { divideInNIntegers } from '../../../../common/mathHelper'
import { globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../../helpers/useTokens'
import { companySettingsAtom } from '../../../../common/jotaiState/commonStateAtoms'
import { downloadPDF } from '../../../Reports/analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../../../common/loginDecode'
import { sortAlphaBy } from '../../common/reportUtils'

const DeliveryFranchiseeCompanyNew = (props) => {
    const {
        data: { common, reports },
        updateModal,
        getFranchiseeDeliveryReportFilterData,
        getFranchiseeDeliveryReportTableData,
        updateAlertError,
        getCompanyList,
        GetMOFPaymentUpdate,
    } = props
    const { methodOfPayment } = common
    const [selCompany, setSelCompany] = useState('')
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [selFranchiseeCity, setSelFranchiseeCity] = useState()
    const [selOwnBookingBranch, setSelOwnBookingBranch] = useState()
    const [selFranchiseeBranch, setSelFranchiseeBranch] = useState()
    const [selOwnBookingCity, setSelOwnBookingCity] = useState()
    const [selOwnBookingBranchUser, setSelOwnBookingBranchUser] = useState()
    const [resetFlag, setResetFlag] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const [isPdfLoading, setIsPdfLoading] = useState(false)
    const [showReport, setShowReport] = useState(false)
    const [manageColumn, setManageColumn] = useState([])
    const [filterData, setFilterData] = useState([])
    const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
    const [paymentMode, setPaymentMode] = useState(paymentModeAll)
    const [paymentModeData, setPaymentModeData] = useState([])
    const [selReportView, setSelReportView] = useState(reportViewList[1])
    const [reportType, setReportType] = useState(reportTypeFranchiseDeliveryFilter[0])
    const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
    const [ChildCompanyList] = useAtom(ChildCompanyListData)
    const reportName = 'Franchisee Deliveries Report'
    const setLoader = useSetAtom(globalLoaderAtom)
    
    const [companySettings] = useAtom(companySettingsAtom)
    const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
    const allowFormatLR = companySettings?.UseFormattedLRinReports
    const UseToPayAsCOD = companySettings?.UseToPayAsCOD
    const DeliveryReportPortrait = companySettings?.DeliveryReportPortrait

    let { loginData = {} } = useToken()
    let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.intCompanyID = +searchParams.get('C') || 0
        loginData.intBranchCityID = +searchParams.get('CT') || 0
        loginData.strCityName = searchParams.get('CTN') || 0
        loginData.intUserID = +searchParams.get('U') || 0
        loginData.intBranchID = +searchParams.get('B') || 0
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        isFromUrl = true
    }
    let { DefaultCurrencyID } = companySettings
    if (!DefaultCurrencyID) {
        DefaultCurrencyID = +searchParams.get('DC') || 1
    }

    const { intCompanyID, intBranchID, intUserID } = loginData

    useEffect(() => {
        const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === intCompanyID) || ChildCompanyList[0];
        setSelCompany(defaultCompany)
    }, [ChildCompanyList])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const body = {
                intCompanyID: intCompanyID,
                UserID: intUserID
            }
            fetchChildCompanyList(body)
        }
    }, [intUserID])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            GetMOFPaymentUpdate({ intBranchID: intBranchID })
            const companylistData = {
                intCompanyID: intCompanyID,
                intUserID: intUserID,
                intMode: 0,
            }
            getCompanyList(companylistData)
        }
    }, [intUserID])
    useEffect(() => {
        if (filterData?.length > 0) {
            let franchiseeCityOption = removeDuplicatesFromArray(filterData, 'FranchiseCity')
            let franchiseeBranchOption = removeDuplicatesFromArray(filterData, 'FranchiseBranchID')
            let ownBookingCityOption = removeDuplicatesFromArray(filterData, 'BookingCity')
            let ownBookingBranchOption = removeDuplicatesFromArray(filterData, 'BookingBranchID')
            let ownBookingBranchuserOption = removeDuplicatesFromArray(filterData, 'UserID')
            setSelFranchiseeCity(franchiseeCityOption[0])
            setSelFranchiseeBranch(franchiseeBranchOption[0])
            setSelOwnBookingCity(ownBookingCityOption[0])
            setSelOwnBookingBranch(ownBookingBranchOption[0])
            setSelOwnBookingBranchUser(ownBookingBranchuserOption[0])

        } 
    }, [filterData])
    const updatedCol = frenchDeliveryUpdatedColumn(allowFormatLR, DefaultCurrencyID, intCompanyID)
    useEffect(() => {
        const getLocalData = (key) => {
            return new Promise((resolve) => {
                const localData = localStorage.getItem(key)
                resolve(localData ? JSON.parse(localData) : null)
            })
        }
        const updateColumnDetails = async () => {
            try {
                const localDelFranchiseeCol = await getLocalData('updatedColKey123V2')
                let filnalcol = localDelFranchiseeCol || updatedCol
                if (DeliveryReportPortrait === 1) {
                    filnalcol = filnalcol.filter((item) => item.isMandatory)
                }
                setManageColumn(filnalcol)
            } catch (error) {
                setManageColumn(updatedCol)
                console.error(error)
            }
        }
        updateColumnDetails()
        focusElemnt(id.selectCompnay)

    }, [DeliveryReportPortrait, DefaultCurrencyID, allowFormatLR])

    useEffect(() => {
        if (methodOfPayment?.status === "Success") {
            const modeData = methodOfPayment?.Data?.Table?.filter((val) => val?.ModeID !== 2)
            setPaymentModeData([paymentModeAll, ...modeData])
        }
    }, [methodOfPayment])
    const onSaveColumns = (item) => {
        setManageColumn(item)
        localStorage.setItem('updatedColKey123V2', JSON.stringify(item))
    }
    let selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
    const mainHeader = ['srNo', 'LRNO', ...(allowFormatLR === 3 ? ['FormattedLRNO'] : []), 'DelDate', 'SrcCity', 'DispByCity', 'SndrName', 'SndrGSTIN', 'RcvrName', 'RcvrGSTIN', 'Item']
  
    let franchiseeCityOption = removeDuplicatesFromArray(filterData, 'FranchiseCity')
    let franchiseeBranchOption = removeDuplicatesFromArray(filterData, 'FranchiseBranchID')
    let ownBookingCityOption = removeDuplicatesFromArray(filterData, 'BookingCity')
    let ownBookingBranchOption = removeDuplicatesFromArray(filterData, 'BookingBranchID')
    let ownBookingBranchuserOption = removeDuplicatesFromArray(filterData, 'UserID')
    const groupedDetailedData = (arr = [], headers) => {
        const lengths = divideInNIntegers(headers.length, 3);
        let index = 0;
        const pickedHeaders = [];
        lengths.forEach((span) => {
            pickedHeaders.push(headers[index].field);
            index += span;
        });
        const grouped = {};
        const SEPARATOR = "|||";
        arr.forEach((val) => {
            const key = [
                val.PaymentType,
                val.PaymentModeName,
                val.DeliveredByBranch
            ].join(SEPARATOR);

            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(val);
        });

        const transform = (list) =>
            list.map((val, i) => ({
                ...val,
                srNo: i + 1,
                'LRNO^^ManualLRNo': `${val.LRNO}\n${val.ManualLRNo}`,
                DelDate: `${moment(val.DeliveryDate).format("DD-MMM-YY")}\n${moment(val.DeliveryDate).format("HH:mm [Hrs]")}`,
                'SourceCity^^SourceBranch': `${val.SourceCity}\n${val.SourceBranch}`,
                'DispatchedByCity^^DispatchedByBranch': `${val.DispatchedByCity}\n${val.DispatchedByBranch}`,
                'Sender^^SenderMobileNo': `${val.Sender}\n${val.SenderMobileNo}`,
                'SenderGSTN^^SenderEmailID': `${val.SenderGSTN}\n${val.SenderEmailID}`,
                'RecName^^RecMobileNo': `${val.RecName}\n${val.RecMobileNo}`,
                'RecGSTN^^RecEmailID': `${val.RecGSTN}\n${val.RecEmailID}`,
                'DeliveredBy^^ItemDetails': `${val.DeliveredBy}\n${val.ItemDetails}`,
                CancelledByUser: val.CancelledByUser || '',
                CancelledByBaseUser: val.CancelledByBaseUser || '',
                dataType: 'entry',
            }));
        const summarize = (list) =>
            list.reduce(
                (acc, val) => {
                    acc.Items += +val.Items || 0;
                    acc.Freight += +val.Freight || 0;
                    acc.KMSFreight += +val.KMSFreight || 0;
                    acc.BkgOtherCharges += +val.BkgOtherCharges || 0;
                    acc.OperatorHamaliChg += +val.OperatorHamaliChg || 0;
                    acc.DeliveryCartage += +val.DeliveryCartage || 0;
                    acc.DeliveryHamali += +val.DeliveryHamali || 0;
                    acc.ExtraHamali += +val.ExtraHamali || 0;
                    acc.DemurrageChg += +val.DemurrageChg || 0;
                    acc.DeliveryGST += +val.DeliveryGST || 0;
                    acc.DeliveryDiscount += +val.DeliveryDiscount || 0;
                    acc.NetAmount += +val.NetAmount || 0;
                    return acc;
                },
                {
                    Items: 0, Freight: 0, KMSFreight: 0, BkgOtherCharges: 0, OperatorHamaliChg: 0,
                    DeliveryCartage: 0, DeliveryHamali: 0, ExtraHamali: 0, DemurrageChg: 0,
                    DeliveryGST: 0, DeliveryDiscount: 0, NetAmount: 0
                }
            );
        const finalData = [];
        const grandTotal = {
            Items: 0, Freight: 0, KMSFreight: 0, BkgOtherCharges: 0, OperatorHamaliChg: 0,
            DeliveryCartage: 0, DeliveryHamali: 0, ExtraHamali: 0, DemurrageChg: 0,
            DeliveryGST: 0, DeliveryDiscount: 0, NetAmount: 0
        };
        Object.entries(grouped).forEach(([key, list]) => {
            const [PaymentType, PaymentModeName, DeliveredByBranch] = key.split(SEPARATOR);

            const transformed = transform([STA_COMPANY_ID].includes(intCompanyID) ? sortAlphaBy(list, ['SourceCity', 'SourceBranch']) : list);
            const summary = summarize(transformed);

            Object.keys(grandTotal).forEach((k) => {
                grandTotal[k] += summary[k] || 0;
            });

            finalData.push({
                colSpan: Object.fromEntries(
                    pickedHeaders.map((key, i) => [key, lengths[i] || 1])
                ),
                align: {
                    [pickedHeaders[0]]: "left",
                    [pickedHeaders[1]]: "center",
                    [pickedHeaders[2]]: "right",
                },
                [pickedHeaders[0]]: `Payment Type: ${PaymentType}`,
                [pickedHeaders[1]]: `Payment Mode: ${PaymentModeName}`,
                [pickedHeaders[2]]: `Branch: ${DeliveredByBranch}`,
                dataType: "subHeader",
                totalSubKey:3,
            });

            finalData.push(...transformed);

            Object.keys(summary).forEach((k) => {
                summary[k] = Number(summary[k].toFixed(2));
            });

            finalData.push({
                ...summary,
                colSpan: {
                    [pickedHeaders[0]]: headers.findIndex(
                        (header) => header.field === "Items"
                    ),
                },
                [pickedHeaders[0]]: `Total: Payment ${PaymentType}, Mode ${PaymentModeName}, Branch ${DeliveredByBranch}`,
                dataType: "total",
                align: { [pickedHeaders[0]]: "right" },
            });
        });

        if (Object.keys(grouped).length > 1) {
            Object.keys(grandTotal).forEach((k) => {
                grandTotal[k] = Number(grandTotal[k].toFixed(2));
            });
            const qtyIndex = headers.findIndex(h => h.field === "Items");
            const colSpanCount = qtyIndex > 0 ? qtyIndex : 1;
            const firstHeader = headers[0]?.field;
            finalData.push({
                ...grandTotal,
                srNo: `Grand Total:All Payment Types / All Payment Modes / All Branches`,
                dataType: "total",
                colSpan: { [firstHeader]: colSpanCount },
                align: {
                    [firstHeader]: "right",
                    [headers[colSpanCount]]: "right"
                }
            });
        }
        return finalData;
    };
    const formatData = (dataArray, DefaultCurrencyID) => {
        let formattedData = [];
        let paymentTypes = {};

        dataArray.forEach((data) => {
            const paymentType = data.PaymentType;
            if (!paymentTypes[paymentType]) {
                paymentTypes[paymentType] = [];
            }
            paymentTypes[paymentType].push(data);
        });

        let overallTotals = {
            ItemUnits: 0,
            FreightCharge: 0,
            KMFreight: 0,
            BkgOthCharge: 0,
            OperatorHamaliChg: 0,
            DelCart: 0,
            DelHam: 0,
            ExtraHameli: 0,
            Demurrage: 0,
            DelGST: 0,
            DelDisc: 0,
            NetAmount: 0

        };

        Object.keys(paymentTypes).forEach(paymentType => {
            formattedData.push({
                srNo: "Payment Type: ", PaymentType: paymentType, colSpan: 13, align: 'left', dataType: 'subHeader'
            });

            let groupTotals = {
                ItemUnits: 0,
                FreightCharge: 0,
                KMFreight: 0,
                BkgOthCharge: 0,
                OperatorHamaliChg: 0,
                DelCart: 0,
                DelHam: 0,
                ExtraHameli: 0,
                Demurrage: 0,
                DelGST: 0,
                DelDisc: 0,
                NetAmount: 0
            };

            paymentTypes[paymentType].forEach((data, index) => {
                const row = {
                    dataType: 'entry',
                    srNo: (index + 1).toString(),
                    PaymentType: data.PaymentType,
                    ItemUnits: data.ItemUnits,
                    FreightCharge: data.FreightCharge,
                    KMFreight: data.KMFreight,
                    BkgOthCharge: data.BkgOthCharge,
                    OperatorHamaliChg: data.OperatorHamaliChg || 0,
                    DelCart: data.DeliveryCartage,
                    DelHam: data.DeliveryHamali,
                    ExtraHameli: data.ExtraHamali,
                    Demurrage: data.DemurrageCharge,
                    DelDisc: data.DelDiscount,
                    NetAmount: data.NetAmount
                };

                if (DefaultCurrencyID !== 2) {
                    row.DelGST = data.DeliveryGST;
                }

                formattedData.push(row);

                groupTotals.ItemUnits += data.ItemUnits;
                groupTotals.FreightCharge += data.FreightCharge;
                groupTotals.KMFreight += data.KMFreight;
                groupTotals.BkgOthCharge += data.BkgOthCharge;
                groupTotals.OperatorHamaliChg += data.OperatorHamaliChg || 0;
                groupTotals.DelCart += data.DeliveryCartage;
                groupTotals.DelHam += data.DeliveryHamali;
                groupTotals.ExtraHameli += data.ExtraHamali;
                groupTotals.Demurrage += data.DemurrageCharge;
                groupTotals.DelDisc += data.DelDiscount;
                groupTotals.NetAmount += data.NetAmount;

                if (DefaultCurrencyID !== 2) {
                    groupTotals.DelGST += data.DeliveryGST;
                }
            });

            const totalRow = {
                dataType: 'total',
                colSpan: { srNo: 2 },
                align: { srNo: 'left' },
                srNo: `Total-${paymentType}`,
                ItemUnits: groupTotals.ItemUnits.toFixed(2),
                FreightCharge: groupTotals.FreightCharge.toFixed(2),
                KMFreight: groupTotals.KMFreight.toFixed(2),
                BkgOthCharge: groupTotals.BkgOthCharge.toFixed(2),
                OperatorHamaliChg: groupTotals.OperatorHamaliChg.toFixed(2),
                DelCart: groupTotals.DelCart.toFixed(2),
                DelHam: groupTotals.DelHam.toFixed(2),
                ExtraHameli: groupTotals.ExtraHameli.toFixed(2),
                Demurrage: groupTotals.Demurrage.toFixed(2),
                DelDisc: groupTotals.DelDisc.toFixed(2),
                NetAmount: groupTotals.NetAmount.toFixed(2)
            };

            if (DefaultCurrencyID !== 2) {
                totalRow.DelGST = groupTotals.DelGST.toFixed(2);
            }

            formattedData.push(totalRow);

            overallTotals.ItemUnits += groupTotals.ItemUnits;
            overallTotals.FreightCharge += groupTotals.FreightCharge;
            overallTotals.KMFreight += groupTotals.KMFreight;
            overallTotals.BkgOthCharge += groupTotals.BkgOthCharge;
            overallTotals.OperatorHamaliChg += groupTotals.OperatorHamaliChg;
            overallTotals.DelCart += groupTotals.DelCart;
            overallTotals.DelHam += groupTotals.DelHam;
            overallTotals.ExtraHameli += groupTotals.ExtraHameli;
            overallTotals.Demurrage += groupTotals.Demurrage;
            overallTotals.DelDisc += groupTotals.DelDisc;
            overallTotals.NetAmount += groupTotals.NetAmount;

            if (DefaultCurrencyID !== 2) {
                overallTotals.DelGST += groupTotals.DelGST;
            }
        });

        const overallTotalRow = {
            dataType: 'total',
            align: "left",
            srNo: 'Total-All',
            ItemUnits: overallTotals.ItemUnits.toFixed(2),
            FreightCharge: overallTotals.FreightCharge.toFixed(2),
            KMFreight: overallTotals.KMFreight.toFixed(2),
            BkgOthCharge: overallTotals.BkgOthCharge.toFixed(2),
            OperatorHamaliChg: overallTotals.OperatorHamaliChg.toFixed(2),
            DelCart: overallTotals.DelCart.toFixed(2),
            DelHam: overallTotals.DelHam.toFixed(2),
            ExtraHameli: overallTotals.ExtraHameli.toFixed(2),
            Demurrage: overallTotals.Demurrage.toFixed(2),
            DelDisc: overallTotals.DelDisc.toFixed(2),
            NetAmount: overallTotals.NetAmount.toFixed(2)
        };

        if (DefaultCurrencyID !== 2) {
            overallTotalRow.DelGST = overallTotals.DelGST.toFixed(2);
        }

        formattedData.push(overallTotalRow);

        return formattedData;
    };
    const criteriaHeaders = [
        { field: 'selCompany', header: 'Selected Company', textAlign: 'left' },
        { field: 'fromDate', header: 'From Delivery Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Delivery  Date', textAlign: 'left' },
        { field: 'selFranchiseeCity', header: 'Franchisee Del. City', textAlign: 'left' },
        { field: 'selFranchiseeBranch', header: 'Franchisee Del. Branch', textAlign: 'left' },
        { field: 'selOwnBookingCity', header: 'Own Booking City', textAlign: 'left' },
        { field: 'selOwnBookingBranch', header: 'Own Booking Branch', textAlign: 'left' },
        { field: 'selOwnBookingBranchUser', header: 'Own Booking Branch User', textAlign: 'left' },
        { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
        { field: 'paymentMode', header: 'Payment Mode', textAlign: 'left' },
        { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
        { field: 'reportType', header: 'Report Type', textAlign: 'left' },
    ]
    const criteriaData = {
        selCompany: selCompany?.CompanyName || '',
        fromDate: fromDate.format('DD-MM-YYYY') || '',
        toDate: toDate.format('DD-MM-YYYY') || '',
        selFranchiseeCity: selFranchiseeCity?.FranchiseCity || '',
        selFranchiseeBranch: selFranchiseeBranch?.FranchiseBranch || '',
        selOwnBookingCity: selOwnBookingCity?.BookingCity || '',
        selOwnBookingBranch: selOwnBookingBranch?.BookingBranch || '',
        selOwnBookingBranchUser: selOwnBookingBranchUser?.Username || '',
        paymentMode: paymentMode?.ModeName || '',
        paymentType: paymentType?.name || '',
        selReportView: selReportView?.name || '',
        reportType: reportType?.Name || '',
        dataType: 'entry',
    }
    const handleGoClick = () => {
        if ((moment(toDate).startOf().diff(moment(fromDate).endOf(), 'days')) > 30) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        }
        else {
            const obj = {
                CompanyID: intCompanyID,
                FranchiseeCompanyID: selCompany?.CompanyID,
                dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
                dtToDate: moment(toDate).format('YYYY-MM-DD'),
                LoginUserID: intUserID
            }
            getFranchiseeDeliveryReportFilterData(obj).then((val) => {
                if (val.status === "Success") {
                    if (val.Data.Table?.length > 0) {
                        setFilterData(val.Data.Table)
                    } else {
                        updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
                    }
                } else {
                    setFilterData([])
                    updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
                }
            })

        }
    }
    const handleClick2 = () => {
        if ((moment(toDate).startOf().diff(moment(fromDate).endOf(), 'days')) > 30) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            let url = urls.deliveryReportFranchisee
            const urlData = urls.deliveryReportFranchiseeParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.intCompanyID = intCompanyID
            urlData.intBranchID = selOwnBookingBranch?.BookingBranchID
            urlData.intUserID = intUserID
            urlData.intFranchCompanyID = selCompany?.CompanyID
            urlData.intFranchBranchID = selFranchiseeBranch?.FranchiseBranchID
            urlData.dtFromDate = fromDate.format('DD-MMM-YYYY')
            urlData.dtToDate = toDate.format('DD-MMM-YYYY')
            urlData.intPaymentType = paymentType?.typeId
            urlData.PaymentType = paymentType?.name
            urlData.BookedByBranch = selOwnBookingBranch?.BookingBranch
            urlData.FranchiseeCompany = selCompany?.CompanyName
            urlData.FranchiseeBranch = selFranchiseeBranch?.FranchiseBranch
            url = appendToUrl(url, urlData);
            window.open(url, "_blank")
        }
    }
    const handleClick1 = (isPdf = false) => {
        const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
        const isAllSelected = selFranchiseeCity?.FranchiseCity === 0 || selFranchiseeBranch?.FranchiseBranchID === 0
        if (isAllSelected && diffDays > 15) {
            updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
        } else if (!isAllSelected && diffDays > 31) {
            updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
        } else {
            if (selFranchiseeCity === "" || selFranchiseeCity === " ") {
                updateAlertError({ show: true, msg: 'Select Franchisee Delivery City', nextId: '' })
            } else {
                setLoader(true)
                const obj = {
                    CompanyID: intCompanyID,
                    BranchID: selOwnBookingBranch?.BookingBranchID,
                    UserID: 0,
                    dtFromDate: moment(fromDate).format("YYYY-MM-DD"),
                    dtToDate: moment(toDate).format("YYYY-MM-DD"),
                    FranchCompanyID: selCompany?.CompanyID,
                    FranchBranchID: selFranchiseeBranch?.FranchiseBranchID,
                    FranchCityID: 0,
                    PaymentType: paymentType?.typeId,
                    PaymentMode: paymentMode?.ModeID,
                    IsCancelled: reportType?.id === 1 ? 1 : 0,
                }
                const isCancelDetailed = reportType?.id === 1 && selReportView?.id !== 0
                getFranchiseeDeliveryReportTableData(obj).then((val) => {
                    setLoader(false)
                    if (val.status === "Success") {
                        let reportData = []
                        let mainHeader = []
                        let reportPayload = {}
                        if (selReportView?.id === 0) {
                            mainHeader = summaryColumn(intCompanyID).map((val) => ({
                                ...val,
                                align: val.headerSx.textAlign,
                                export: val.exportHead,
                                weight: 80
                            }))
                            if (val?.Table1?.length > 0) {
                                reportData = formatData(val?.Table1, DefaultCurrencyID)
                            }
                            reportPayload = {
                                reportName: reportName + ' (Summary)',
                                criteriaHeaders: criteriaHeaders,
                                criteriaData: [criteriaData],
                                tableData: reportData,
                                mainHeader: mainHeader,
                                serialNokey: 'srNo',
                                showColumnBorders: true,
                            }
                            if (isPdf === true) {
                                downloadPDF({
                                    reportName: reportName + ' (Summary)',
                                    criteriaHeaders,
                                    criteriaData: [criteriaData],
                                    tableData: reportData,
                                    visibleColumns: mainHeader,
                                    loginData,
                                    showColumnBorders: true,
                                    hideHeader: false
                                })
                                return
                            }
                        } else {
                            const detailedColumns = isCancelDetailed ? cancelFranchiseDeliveryDetailedColumn() : manageColumn
                            const detailedReportName = isCancelDetailed ? 'Cancel Franchise Delivery (Detailed)' : reportName + ' (Detailed)'
                            mainHeader = detailedColumns.filter((obj) => obj.isSelected)?.map((val) => ({
                                ...val,
                                align: val.headerSx.textAlign,
                                export: val.exportHead,
                                weight: 80
                            }))
                            if (val?.Table?.length > 0) {
                                reportData = groupedDetailedData(val?.Table, mainHeader)
                            }
                            reportPayload = {
                                reportName: detailedReportName,
                                criteriaHeaders: criteriaHeaders,
                                criteriaData: [criteriaData],
                                tableData: reportData,
                                mainHeader: mainHeader,
                                isShowManageColumn: true,
                                manageColumnID: isCancelDetailed ? 'cancelFranchiseDeliveryColumnV2' : 'updatedColKey23V2',
                                colSpanMarker: "DeliveredBy^^ItemDetails",
                                serialNokey: 'srNo',
                                showColumnBorders: true,
                                totalSubKey: 3,
                                ...([STA_COMPANY_ID].includes(intCompanyID) ? { defaultSortConfig: { field: 'SourceCity^^SourceBranch', direction: 'asc' } } : {}),
                            }
                            if (isPdf === true) {
                                downloadPDF({
                                    reportName: detailedReportName,
                                    criteriaHeaders,
                                    criteriaData: [criteriaData],
                                    tableData: reportData,
                                    visibleColumns: mainHeader,
                                    loginData,
                                    showColumnBorders: true,
                                    hideHeader: false
                                })
                                return
                            }
                        }
                        const rid = Date.now().toString()

                        if (!window.generatedReports) {
                            window.generatedReports = {}
                        }

                        window.generatedReports[rid] = reportPayload

                        window.open(`/view-report?rid=${rid}`, "_blank")

                    } else {
                        setShowReport(false)
                        updateAlertError({ show: true, msg: val?.ErrMessage, nextId: '' })
                    }
                })
            }
        }
    }
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={id.selectCompnay}
                            nextId={id.fromDate}
                            prevId={showReport ? isPdfLoading ? "backBtn" : 'printBtn' : id.reportmainButton}
                            label="Selected Company"
                            data={ChildCompanyList}
                            defaultvalue={selCompany?.CompanyName}
                            disabled={ChildCompanyList?.length > 0 ? false : true}
                            onSelect={(e) => {
                                setSelCompany(e)
                                setShowReport(false)
                                focusElemnt(id.fromDate)
                            }}
                            dataKey={`CompanyName`}
                            idKey={`CompanyID`}
                            minWidth={isFromUrl ? '100%' : '300px'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            name={'from_date'}
                            label={`From Delivery Date`}
                            value={fromDate}
                            id={id.fromDate}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt(id.toDate)
                            }}
                            width="100%"
                            startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)}
                            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
                        />
                    </Item>
                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
                        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                            <Datepicker
                                name={'to_date'}
                                label={`To Delivery Date`}
                                id={id.toDate}
                                value={toDate}
                                dateChange={(date) => {
                                    setToDate(date)
                                    focusElemnt('filterGo')
                                }}
                                width="100%"
                                startDate={fromDate}
                                endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}

                            />
                        </Item>
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button id='filterGo' variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                                onKeyDown={(e) => {
                                    navigation3(e, id.FranchiseeDelCity, id.toDate, () => { })
                                }}
                                onClick={handleGoClick}
                            >
                                GO
                            </Button>
                        </Item>
                    </Box>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={'Franchisee Del. City'}
                            id={id.FranchiseeDelCity}
                            data={franchiseeCityOption}
                            defaultvalue={selFranchiseeCity?.FranchiseCity || selFranchiseeCity}
                            resetFlag={resetFlag}
                            dataKey={`FranchiseCity`}
                            idKey={`FranchiseCity`}
                            width="100%"
                            nextId={id.FranchiseeDelBranch}
                            prevId={'filterGo'}
                            onSelect={(e) => {
                                setSelFranchiseeCity(e)
                                setShowReport(false)
                            }}
                        />
                    </Item>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            label={'Franchisee Del. Branch'}
                            id={id.FranchiseeDelBranch}
                            data={franchiseeBranchOption}
                            defaultvalue={selFranchiseeBranch?.FranchiseBranch || selFranchiseeBranch}
                            resetFlag={resetFlag}
                            dataKey={`FranchiseBranch`}
                            idKey={`FranchiseBranchID`}
                            width="100%"
                            nextId={id.OwnBookingCity}
                            prevId={id.FranchiseeDelCity}
                            onSelect={(e) => {
                                setSelFranchiseeBranch(e)
                                setShowReport(false)
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label={lb.OwnBookingCity}
                            id={id.OwnBookingCity}
                            data={ownBookingCityOption}
                            defaultvalue={selOwnBookingCity?.BookingCity || selOwnBookingCity}
                            resetFlag={resetFlag}
                            dataKey={`BookingCity`}
                            idKey={`BookingCity`}
                            width={isFromUrl ? '100%' : '200px'}
                            nextId={id.OwnBookingBranch}
                            prevId={id.FranchiseeDelBranch}
                            onSelect={(e) => {
                                setSelOwnBookingCity(e)
                                setShowReport(false)
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label={lb.OwnBookingBranch}
                            id={id.OwnBookingBranch}
                            data={ownBookingBranchOption}
                            defaultvalue={selOwnBookingBranch?.BookingBranch || selOwnBookingBranch}
                            resetFlag={resetFlag}
                            dataKey={`BookingBranch`}
                            idKey={`BookingBranchID`}
                            width={isFromUrl ? '100%' : '180px'}
                            nextId={id.OwnBkgBranchUser}
                            prevId={id.OwnBookingCity}
                            onSelect={(e) => {
                                setSelOwnBookingBranch(e)
                                setShowReport(false)
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label={lb.OwnBkgBranchUser}
                            id={id.OwnBkgBranchUser}
                            data={ownBookingBranchuserOption}
                            defaultvalue={'All'}
                            // disabled={true}
                            disabled={loginData?.intCompanyID !== TULSI_TRAVEL}
                            resetFlag={resetFlag}
                            dataKey={`Username`}
                            idKey={`UserID`}
                            width={isFromUrl ? '100%' : '190px'}
                            nextId={id.paymentType}
                            prevId={id.OwnBookingBranch}
                            onSelect={(e) => {
                                setSelOwnBookingBranchUser(e)
                                setShowReport(false)
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label={lb.paymentType}
                            id={id.paymentType}
                            data={
                                (paymentModesWithAll || []).map((item) => {
                                    if (UseToPayAsCOD === 1) {
                                        if (item.typeId === 2) {
                                            return { ...item, name: 'COD' };
                                        }
                                        if (item.typeId === 7) {
                                            return { ...item, name: 'COD Manual' };
                                        }
                                        if (item.typeId === 9) {
                                            return { ...item, name: 'COD DDDV' };
                                        }
                                        if (item.typeId === 4) {
                                            return null;
                                        }
                                    }
                                    return item;
                                }).filter(Boolean)
                            }
                            resetFlag={resetFlag}
                            dataKey={`name`}
                            idKey={`typeId`}
                            width={isFromUrl ? '100%' : '180px'}
                            nextId={id.PaymentMode}
                            prevId={id.OwnBkgBranchUser}
                            defaultvalue={paymentType?.name}
                            onSelect={(value) => {
                                setPaymentType(value)
                                setShowReport(false)
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label={lb.PaymentMode}
                            id={id.PaymentMode}
                            data={paymentModeData || []}
                            defaultvalue={paymentModeData?.length > 0 && paymentMode?.ModeName}
                            resetFlag={resetFlag}
                            dataKey={`ModeName`}
                            idKey={`ModeID`}
                            width={isFromUrl ? '100%' : '185px'}
                            nextId={'ReportType'}
                            prevId={id.paymentType}
                            onSelect={(value) => {
                                setPaymentMode(value)
                                setShowReport(false)
                            }}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id="ReportType"
                            label="Report Type"
                            data={reportTypeFranchiseDeliveryFilter}
                            defaultvalue={reportType?.Name || reportTypeFranchiseDeliveryFilter[0].Name}
                            onSelect={(value) => {
                                setReportType(value)
                                setShowReport(false)
                            }}
                            resetFlag={resetFlag}
                            dataKey={`Name`}
                            idKey={`id`}
                            width={isFromUrl ? '100%' : '240px'}
                            nextId={id.reportView}
                            prevId={id.PaymentMode}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label={lb.reportView}
                            id={id.reportView}
                            data={reportViewList || []}
                            defaultvalue={selReportView?.name || selReportView}
                            value={selReportView?.name || selReportView}
                            onSelect={(value) => {
                                setSelReportView(value)
                                setShowReport(false)
                            }}
                            resetFlag={resetFlag}
                            dataKey={`name`}
                            idKey={`id`}
                            width={isFromUrl ? '100%' : '185px'}
                            nextId={id.reportmainButton}
                            prevId={'ReportType'}
                        />
                    </Item>
                    {isFromUrl ?
                        <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={id.reportmainButton}>
                            DOWNLOAD PDF
                        </Button> :
                        <>
                            <Item sx={sx.itemsx}
                                onKeyDown={(e) => {
                                    navigation3(e, showReport ? isPdfLoading ? "backBtn" : disableExcel ? "exportPdf" : "exportExcelBtn" : id.selectCompnay, id.reportView, () => { })
                                }}
                            >
                                <SplitButton
                                    options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                                    hideToggle={false}
                                    id1={id.reportmainButton}
                                    onClick1={handleClick1}
                                    onClick2={handleClick2}
                                />
                            </Item>
                        </>}
                </Box>
            </Item >
        </>
    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getFranchiseeDeliveryReportFilterData, updateAlertError, getFranchiseeDeliveryReportTableData, getCompanyList, GetMOFPaymentUpdate }

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryFranchiseeCompanyNew)
